var map = {
	"./avatar-placeholder.png": 894,
	"./credit.svg": 9529,
	"./diagram.svg": 8279,
	"./idea.svg": 3442,
	"./logo.png": 5080,
	"./logo.svg": 5522,
	"./noimage-placeholder.svg": 8159,
	"./payoneer.svg": 3775,
	"./paypal.svg": 1195,
	"./star.svg": 6338
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;